/**
 * @dramadetector/ui — Share Card Components
 *
 * Shared share card components used by both apps/mobile and apps/web-landing.
 * Extracted to eliminate cross-app duplication (DD-Sprint-9).
 *
 * Usage:
 *   import { ShareCardTemplate, ShareCardRenderer } from '@dramadetector/ui/share';
 *   import type { ShareCardData, ShareFormat } from '@dramadetector/ui/share';
 */

// Card components
export { ShareCardTemplate } from "./ShareCardTemplate";
export type { ShareCardTemplateProps } from "./ShareCardTemplate";
export { INSTAGRAM_STORIES_DIMENSIONS } from "./ShareCardTemplate";

export { ShareCardRenderer } from "./ShareCardRenderer";
export type {
	ShareCardRendererProps,
	ShareCardRendererRef,
	ShareCardData,
} from "./ShareCardRenderer";

export { ShareCardPreview } from "./ShareCardPreview";
export type { ShareCardPreviewProps } from "./ShareCardPreview";
export type {
	NarratorCardData,
	ExpertCardData,
	CombinedCardData,
} from "./ShareCardRenderer";

export { NarratorShareCard } from "./NarratorShareCard";
export { ExpertShareCard } from "./ExpertShareCard";
export { CombinedShareCard } from "./CombinedShareCard";
